var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('component-wrapper',{attrs:{"config":_vm.component},nativeOn:{"click":function($event){return _vm.showCheckin.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }